<template>
    <tailwind-layout title="Applicants">
        <template #header>
            Applicants
        </template>

        <div class="py-12">
            <div class="bg-white overflow-hidden shadow-xl sm:rounded-lg">
                <div v-if="validationErrors[0]" class="text-red-500 py-2 px-4 pr-0 font-bold mb-4">
                    <ul v-for="error in validationErrors">
                        <li>{{ error }}</li>
                    </ul>
                </div>
                <div class="bg-white py-16 px-4 overflow-hidden sm:px-6 lg:px-8 lg:py-24">
                    <div class="relative max-w-xl mx-auto">
                        This is the applicants page.
                    </div>
                </div>
            </div>
        </div>
    </tailwind-layout>
</template>

<script>
import TailwindLayout from '@/Layouts/TailwindLayout.vue'
import LoadingButton from '@/Shared/LoadingButton.vue'


export default {
    props: {
        errors: null,
    },
    components: {
        TailwindLayout,
    },
    data() {
        return {
        }
    },
    mounted: function () {
    },
    computed: {
        validationErrors(){
            let errors = Object.values(this.errors);
            errors = errors.flat();
            return errors;
        }
    },
    methods: {
    }
}
</script>
